// extracted by mini-css-extract-plugin
module.exports = {"u1ooab2r":"u1ooab2r","l19qbhhc":"l19qbhhc","l1uisxzp":"l1uisxzp"};